'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {
	return {
		/**
		 * returns configured textModules of the given category if textModules are activated. When textModules are
		 * not activated the API answers with a 403 status code.
		 */
		getTextModules:
			$resource(
				apiConfig.$get().apiUrl + '/text-module/:category',
				{
					category: '@category'
				},
				{
					get: {
						isArray: true
					}
				}
			)
	}
}
